import React, { Children, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIsSSCOMBrand } from '../../../hooks/useIsSSCOMBrand';
import styles from './NavigationBlock.module.css';

const NavigationBlock = ({ title, children, className, ...props }) => {
  const isSCCOMbrand = useIsSSCOMBrand();
  return (
    <div
      className={classNames(
        styles.component_ig,
        isSCCOMbrand && styles.component_ig_sccom,
        className
      )}
      {...props}
    >
      {title}

      <ul className={styles.list_ig}>
        {Children.toArray(children)
          .filter((child) => isValidElement(child))
          .map((child, index) => (
            <li key={child.key} className={styles.item_ig}>
              {child}
            </li>
          ))}
      </ul>
    </div>
  );
};

NavigationBlock.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]),
};

NavigationBlock.defaultProps = {
  title: '',
};

export default NavigationBlock;
